exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".blurred {\r\n  filter: blur(5px);\r\n  user-select: none;\r\n  pointer-events: none;\r\n}\r\n", ""]);

// exports
